import "./TestStyles.css";
import React, { useState, useRef, useEffect, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { calculate_progress } from "../utils/progress_bar.js";
import { StartAudio, EndAudio, handleAudioEnded, playInstructionsOnce } from '../utils/audio_utils.js';
import { handleOnPopState } from '../utils/state_handler.js';
import { timerEnded, startTimer, handleTimeoutNavigation } from '../utils/timer_utils';
import { startRecording } from '../utils/recording_utils.js';

const QuestionSixBScreen = ({ userData }) => {
  // Initialize S3 instance
  const [audio] = useState(new Audio("/audio/q6B_instructions.mp3"));
  
  const [isRecording, setIsRecording] = useState(false);
  const [recordingButtonDisabled, setRecordingButtonDisabled] = useState(true);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [imageButtonContainerStyle, setImageButtonContainerStyle] = useState("ImageButtonContainer");
  const [nextButtonStyle, setNextButtonStyle] = useState("NextButton");
  const [audioPlayed, setAudioPlayed] = useState(false);
  const [, setRecordingExists] = useState(false);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const results = JSON.parse(localStorage.getItem("results"));
  const [seconds, setSeconds] = useState(60);
  const [isActive, setIsActive] = useState(false);
  const [beginTimer, setBeginTimer] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [nextPage] = useState("/Q7Screen");        // Where this screen will navigate to next
  const [thisPage] = useState("screen_6_b");
  const [filenameSuffix] = useState("Q6B");

  // Create a ref to always hold the latest isActive value
  const isActiveRef = useRef(isActive);
  useEffect(() => {
      isActiveRef.current = isActive;
    }, [isActive]);

  window.onpopstate = () => {
    handleOnPopState(userData, navigate, location);
  };

  const onInstructionsEnded = useCallback(
    () =>
      handleAudioEnded(
        setButtonDisabled,
        setRecordingButtonDisabled,
        setImageButtonContainerStyle,
        setNextButtonStyle,
        audio,
        setAudioPlayed
      ),
    [audio]
  );

  // Play instructions once after rendering
  useEffect(() => {
    playInstructionsOnce({ audio, audioPlayed, setAudioPlayed, onEnded: onInstructionsEnded });
  }, [audio, audioPlayed, onInstructionsEnded]);

  // Set up Timer using updated startTimer
  useEffect(() => {
    if (beginTimer) {
      const interval = startTimer(
        () => isActiveRef.current,
        seconds,
        setSeconds,
        () =>
          timerEnded(
            isActiveRef.current,
            stopRecording,
            () =>
              handleTimeoutNavigation(
                navigate,
                setRecordingButtonDisabled,
                setImageButtonContainerStyle,
                nextPage
              )
          )
      );
      return () => clearInterval(interval);
    }
  }, [beginTimer, seconds, navigate, nextPage]);

  // Audio helper in the component for beep start
  

  // Start recording
  const handleStartRecording = async () => {
    setIsActive(true);
    setBeginTimer(true);
    StartAudio(); // your beep start
    setImageButtonContainerStyle("ImageButtonContainerRecording");
    
    await startRecording({
      setImageButtonContainerStyle,
      audioChunksRef,
      mediaRecorderRef,
      setIsRecording,
      setRecordingExists,
      userData,
      screenId: thisPage,
      screenTag: filenameSuffix,
      results,
      recordingStyle: "ImageButtonContainerRecording",
    });
  };

  // Stop recording function updated to use EndAudio
  const stopRecording = async () => {
    if (!mediaRecorderRef.current) return;
    setIsRecording(false);
    EndAudio();
    mediaRecorderRef.current.stop();
    await mediaRecorderRef.current.stopPromise;
    setImageButtonContainerStyle("ImageButtonContainerComplete");
  };

  

  // User interface
  return (
    <div className="Container">
      <div className="InstructionsContainer">
        <img className="CharacterIcon" src="/icons/other.png" alt="Character Icon" />
        <progress
          variant="custom"
          className="ProgressBar"
          value={calculate_progress("asymptotic", 8, 54)}
          max="1"
        ></progress>
        <p className="Instructions">
          Press the microphone and name as many animals as you can.
        </p>
      </div>
      <div>
        {isRecording ? (
          <button
            className={imageButtonContainerStyle}
            disabled={recordingButtonDisabled}
            onClick={stopRecording}
          >
            <img
              className="microphoneIcon"
              src="/icons/microphone.png"
              alt="Microphone Button"
            />
          </button>
        ) : (
          <button
            className={imageButtonContainerStyle}
            disabled={recordingButtonDisabled}
            onClick={handleStartRecording}
          >
            <img
              className="microphoneIcon"
              src="/icons/microphone.png"
              alt="Microphone Button"
            />
          </button>
        )}
      </div>

      <div className="NextButtonContainer">
        <button disabled={buttonDisabled} onClick={async () => {
          if (isRecording) {
            await stopRecording();
          }
          navigate(nextPage)
          }} className={nextButtonStyle}>
          <img src="/icons/arrow.png" alt="Next Button" />
        </button>
      </div>
    </div>
  );
};

export default QuestionSixBScreen;
